// TEMPLATE - copy to src/firebase/config.js and modify accordingly

import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  //connectFirestoreEmulator // COMMENT TO DEPLOY
} from 'firebase/firestore';
import {
  getAuth,
  //connectAuthEmulator // COMMENT TO DEPLOY
} from 'firebase/auth';

// init firebase - Copy the values from the Project Settings page on the Firebase project's console (and create WEB app with firebase hosting, if not done yet)
initializeApp({
  apiKey: "AIzaSyCwQJDQzztpGXxr3oknezG2rPw5UtIcNmQ",
  authDomain: "heylight-visioni-dev.firebaseapp.com",
  projectId: "heylight-visioni-dev",
  storageBucket: "heylight-visioni-dev.firebasestorage.app",
  messagingSenderId: "458428084930",
  appId: "1:458428084930:web:9ab0bd582c5fa2b22f015b"
  //  measurementId: "uuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu"
});
// init services
const db = getFirestore();
const auth = getAuth();

// use emulator -- COMMENT TO DEPLOY
//connectFirestoreEmulator(db, 'holipay.visioni.io', 8080);
//connectAuthEmulator(auth, 'http://holipay.visioni.io:9099');

export { db, auth }
